import createTypes from 'redux-create-action-types';

export default createTypes(
  'NOTIFICATIONS_ADD',
  'NOTIFICATIONS_DISMISS',
  'NOTIFICATIONS_REMOVE',
  'NOTIFICATIONS_REMOVE_ALL',
);
